import React, { useEffect, useState } from "react";
import axios from "../../axios/axios";
import img1 from "../../images/banner1.jpg";
import img2 from "../../images/banner1.jpg";
import img3 from "../../images/banner1.jpg";
import img4 from "../../images/banner1.jpg";
import Sidebar from "./Sidebar";

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [errorMessage, seterrorMessage] = useState("");

  useEffect(() => {
    getUsers();
  }, []);

  //get user
  const getUsers = async () => {
    try {
      const response = await axios.get("/user/allUsers");
      setUsers(response.data);
    } catch (error) {
      console.log(error);
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <div>
      <Sidebar />

      <div className="home-section">
        <div className="text">
          <div class="main-content">
            {errorMessage && (
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                {errorMessage}
                <button
                  type="button"
                  class="btn-close shadow-none"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            )}
            <section class="section mt-5">
              <div class="d-flex flex-wrap gap-3">
                <div class="">
                  <div class="card translate-card py-3 ps-3">
                    <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                        <div class="row ">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div class="card-content">
                              <h5 class="font-15">Total Bookings</h5>
                              <h2 class="mb-3 font-18">{users.length}</h2>
                              <p class="mb-0">
                                <span class="text-success lead">10%</span>{" "}
                                Increase
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div class="banner-img">
                              <img src={img1} alt="" className="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="card py-3 ps-3 translate-card">
                    <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                        <div class="row ">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div class="card-content">
                              <h5 class="font-15">Total Customers</h5>
                              <h2 class="mb-3 font-18">1,287</h2>
                              <p class="mb-0">
                                <span class="text-warning lead">09%</span>{" "}
                                Decrease
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div class="banner-img">
                              <img src={img2} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="card py-3 ps-3 translate-card">
                    <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                        <div class="row ">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div class="card-content">
                              <h5 class="font-15">New Bookings</h5>
                              <h2 class="mb-3 font-18">128</h2>
                              <p class="mb-0">
                                <span class="text-success lead">18% </span>
                                Increase
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div class="banner-img">
                              <img src={img3} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="">
                  <div class="card py-3 ps-3 translate-card">
                    <div class="card-statistic-4">
                      <div class="align-items-center justify-content-between">
                        <div class="row ">
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pr-0 pt-3">
                            <div class="card-content">
                              <h5 class="font-15">All Happy Clients</h5>
                              <h2 class="mb-3 font-18">$48,69</h2>
                              <p class="mb-0">
                                <span class="text-success lead">42%</span>{" "}
                                Increase
                              </p>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 pl-0">
                            <div class="banner-img">
                              <img src={img4} alt="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
